import apiClient, { getApiErrorMessage } from './apiClient';

const unwrapApiData = (data) => data?.data || data?.Data || data;

const unwrapApiList = (data) => {
  if (Array.isArray(data)) {
    return data;
  }

  const unwrapped = unwrapApiData(data);

  if (Array.isArray(unwrapped)) {
    return unwrapped;
  }

  if (Array.isArray(unwrapped?.items)) {
    return unwrapped.items;
  }

  if (Array.isArray(unwrapped?.Items)) {
    return unwrapped.Items;
  }

  return [];
};

const normalizeOwner = (owner) => ({
  fullName: owner?.FullName || owner?.fullName || '',
  avatarUrl: owner?.AvatarUrl || owner?.avatarUrl || ''
});

const normalizeCategory = (category) => ({
  id: category?.Id || category?.id || '',
  name: category?.Name || category?.name || ''
});

export const normalizePublicProject = (project) => ({
  id: project?.Id || project?.id || '',
  title: project?.Title || project?.title || '',
  description: project?.Description || project?.description || '',
  deploymentUrl: project?.DeploymentUrl || project?.deploymentUrl || '',
  coverImageUrl: project?.CoverImageUrl || project?.coverImageUrl || '',
  viewCount: project?.ViewCount ?? project?.viewCount ?? null,
  categories: (project?.Categories || project?.categories || [])
    .map(normalizeCategory)
    .filter((item) => item.id),
  owner: normalizeOwner(project?.Owner || project?.owner || {})
});

export const fetchPublicProjectsApi = async ({ categoryId } = {}) => {
  try {
    const params =
      categoryId && categoryId !== 'all' ? { categoryId } : undefined;
    const { data } = await apiClient.get('/public/projects', { params });
    return unwrapApiList(data).map(normalizePublicProject).filter((project) => project.id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Public projects request failed.'));
  }
};

export const fetchPublicProjectByIdApi = async (projectId) => {
  try {
    const { data } = await apiClient.get(`/public/projects/${encodeURIComponent(projectId)}`);
    return normalizePublicProject(unwrapApiData(data));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Public project request failed.'));
  }
};
